module.exports = __webpack_public_path__ + "img/horizontal_2_1_r_7042.2aea5280.png";